import { render, staticRenderFns } from "./PanelDetails.vue?vue&type=template&id=7f9f1eeb&"
import script from "./PanelDetails.vue?vue&type=script&lang=ts&"
export * from "./PanelDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports